import React, { useState, useEffect } from "react";
import { handleSignup, checkToken, getDhanProfile } from "../../services/apicall.tsx";
import { useUserContext, Statescontex } from "../../context/index.js";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Input, Button, Form, Typography, Select } from "antd";
import { colors } from "../../devdata/constants/themes";
import { Anilogsign } from "../../components";
import expandedLogo from "../../devdata/icons/marketpulse.svg";
import GoogleBulbul from "../../components/oauth/google_login.tsx";
import DhanLogin from "../../components/oauth/dhan_login.tsx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
const { Text } = Typography;
const { Option } = Select;

const UserSignUp = () => {
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  const [isTouched, setIsTouched] = useState(false);
  const navi = useNavigate()

  const [searchParams] = useSearchParams();
  const [currentStep, setCurrentStep] = useState(0);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [isValidPassword, setisValidPassword] = useState("");
  const [passwordConfirm, setConfirmPassword] = useState("");
  const [G, setG] = useState(false);
  const [D, setD] = useState(false);
  const [address, setAddress] = useState({
    house: "",
    area: "",
    city: "",
    state: "",
    country: "",
    pin: "",
  });
  const [gender, setGender] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [pan, setPan] = useState("");
  const [loading, setLoading] = useState(false);
  const [refc, setRefc] = useState("");
  const [IsrefcodePresent, setIsrefcodePresent] = useState(false);
  const [isKeyboardActive, setIsKeyboardActive] = useState(false);
  const { setErrorshow, setErrorMessage } = Statescontex();
  const { setuserToken, setlogin, userToken, isloggedin, userdetails } =
    useUserContext();
  useEffect(() => {
    const refcode = searchParams.get("refcode");
    setRefc(refcode);
    setIsrefcodePresent(!!refcode);
  }, [searchParams]);

  useEffect(() => {
    setisValidPassword(passwordRegex.test(password))
  }, [password])
  useEffect(() => {
    const tokenId = searchParams.get("tokenId");
    const from = sessionStorage.getItem("from")
    if (tokenId && from) {
      sessionStorage.removeItem("from")
      getDhanProfile(tokenId, setPassword, setConfirmPassword, setName, setD, setErrorshow, setErrorMessage, setLoading, false)
    }
  }, [])

  useEffect(() => {
    const details = JSON.parse(sessionStorage.getItem("loginTosignup"));
    // console.log(details);

    if (details) {
      setPassword(details.pass)
      setConfirmPassword(details.pass)
      setName(details.name)
      if (details.dhan === true) {
        setD(true)
      }
      else {
        setEmail(details.email)
        setG(true)
      }
      sessionStorage.removeItem("loginTosignup")

    }
  }, [])

  // Add keyboard event listeners
  useEffect(() => {
    const handleKeyboardDidShow = () => {
      setIsKeyboardActive(true);
    };

    const handleKeyboardDidHide = () => {
      setIsKeyboardActive(false);
    };

    // For mobile web, we'll use focus/blur events on inputs as a proxy for keyboard visibility
    const inputElements = document.querySelectorAll("input");

    inputElements.forEach((input) => {
      input.addEventListener("focus", handleKeyboardDidShow);
      input.addEventListener("blur", handleKeyboardDidHide);
    });

    return () => {
      inputElements.forEach((input) => {
        input.removeEventListener("focus", handleKeyboardDidShow);
        input.removeEventListener("blur", handleKeyboardDidHide);
      });
    };
  }, []);

  const steps = [
    {
      title: "Personal Info",
      content: (
        <>
          {!G && !D && (
            <>
              <Form.Item
                label={
                  <label style={{ color: colors.darkMode.text }}>
                    Full Name
                  </label>
                }
                name="name"
                required
              >
                <Input
                  type="text"
                  // placeholder="Enter your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  style={{
                    borderRadius: "0.5rem",
                    padding: "0.75rem",
                    color: "black",
                  }}
                  className="!bg-white !border-gray-300 focus:!ring-darkMode-greenDarker focus:ring-2 focus:!shadow-none"
                />
              </Form.Item>
              <Form.Item
                label={
                  <label style={{ color: colors.darkMode.text }}>Email</label>
                }
                name="email"
                required
              >
                <Input
                  type="email"
                  // placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={{
                    borderRadius: "0.5rem",
                    padding: "0.75rem",
                    color: "black",
                  }}
                  className="!bg-white !border-gray-300 focus:!ring-darkMode-greenDarker focus:ring-2 focus:!shadow-none"
                />
              </Form.Item>
            </>
          )}

          {D && <Form.Item
            label={
              <label style={{ color: colors.darkMode.text }}>Email</label>
            }
            name="email"
            required
          >
            <Input
              type="email"
              // placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                borderRadius: "0.5rem",
                padding: "0.75rem",
                color: "black",
              }}
              className="!bg-white !border-gray-300 focus:!ring-darkMode-greenDarker focus:ring-2 focus:!shadow-none"
            />
          </Form.Item>}
          <Form.Item
            label={
              <label style={{ color: colors.darkMode.text }}>
                Phone Number
              </label>
            }
            name="phone"
            required
          >
            <Input
              type="tel"
              // placeholder="Enter your phone number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              style={{
                borderRadius: "0.5rem",
                padding: "0.75rem",
                color: "black",
              }}
              className="!bg-white !border-gray-300 focus:!ring-darkMode-greenDarker focus:ring-2 focus:!shadow-none"
            />
          </Form.Item>
          {!G && !D && (
            <>
              <Form.Item
                label={
                  <label style={{ color: colors.darkMode.text }}>
                    Password
                  </label>
                }
                name="password"
                required
              >
                <Input.Password
                  // placeholder="Enter your password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setIsTouched(true);
                  }}
                  style={{
                    borderRadius: "0.5rem",
                    padding: "0.75rem",
                    color: "black",
                  }}
                  iconRender={visible => (
                    visible ? <FontAwesomeIcon icon={faEyeSlash} style={{ width: 20, height: 20 }} color="black" /> : <FontAwesomeIcon icon={faEye} style={{ width: 20, height: 20 }} color="black" />
                  )}
                  className="!bg-white !border-gray-300 focus:!ring-darkMode-greenDarker focus:ring-2 focus:!shadow-none"
                />
                <Text hidden={!isTouched} className="pt-5">
                  <Text type="danger" style={{ fontSize: '0.875rem' }} hidden={isValidPassword}>
                    Password must be at least 8 characters and include uppercase, lowercase, number, and special character.
                  </Text>
                </Text>


              </Form.Item>
              <Form.Item
                label={
                  <label style={{ color: colors.darkMode.text }}>
                    Confirm Password
                  </label>
                }
                name="confirmPassword"
                required
              >
                <Input.Password
                  // placeholder="Confirm your password"
                  value={passwordConfirm}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  style={{
                    borderRadius: "0.5rem",
                    padding: "0.75rem",
                    color: "black",
                  }}
                  iconRender={visible => (
                    visible ? <FontAwesomeIcon icon={faEyeSlash} style={{ width: 20, height: 20 }} color="black" /> : <FontAwesomeIcon icon={faEye} style={{ width: 20, height: 20 }} color="black" />
                  )}
                  className="!bg-white !border-gray-300 focus:!ring-darkMode-greenDarker focus:ring-2 focus:!shadow-none"
                />
              </Form.Item>
            </>
          )}
        </>
      ),
    },
  ];

  const nextStep = () => setCurrentStep((prev) => prev + 1);
  const prevStep = () => setCurrentStep((prev) => prev - 1);

  const handleSubmit = () => {
    if (password !== passwordConfirm) {
      console.log("Passwords do not match");
      return;
    }

    if (currentStep === steps.length - 1) {
      setLoading(true);
      handleSignup(
        name,
        email,
        parseInt(phone),
        password,
        passwordConfirm,
        refc,
        "",
        G,
        D,
        "+91",
        address,
        gender,
        birthdate,
        pan,
        setLoading,
        setuserToken,
        setlogin,
        setErrorMessage,
        setErrorshow
      );
    }
  };

  useEffect(() => {
    if (
      userToken &&
      userToken !== "loggedout" &&
      userToken !== "Expired" &&
      !isloggedin
    ) {
      checkToken(
        userToken,
        setLoading,
        setuserToken,
        setlogin,
        setErrorMessage,
        setErrorshow
      );
    }
  }, [userToken]);

  useEffect(() => {
    if (isloggedin && userToken) {
      if (userdetails?.role === "user") {
        navi(userdetails.isverified === true ? "/Dashboard" : "/verify", { replace: true })
      }
    }
  }, [userdetails, isloggedin]);

  return (
    <div className="flex flex-col sm:flex-row h-auto">
      {/* Left Green Section - Hidden on Mobile */}
      <div className="hidden relative sm:block sm:w-1/2  h-auto bg-gradient-to-br from-[#005C32] to-[#11CD77]">
        <div
          style={{ position: "absolute", top: "30%" }}
          className="hidden lg:block xl:left-1/2 xl:-translate-x-1/2 lg:left-1/2 lg:-translate-x-1/2"
        >
          <Anilogsign />
        </div>
        <img
          alt="bars"
          src={require("../../devdata/assets/bars.png")}
          className="h-screen"
        />
      </div>
      {/* Right Section - Form */}
      <div className="w-full sm:w-1/2 flex flex-col justify-center items-center px-6 sm:px-10 bg-darkMode-background min-h-screen ">
        {/* Logo - Hide when keyboard is active */}
        {!isKeyboardActive && (
          <div className="absolute top-8">
            <Link to={"/"}>
              <img src={expandedLogo} alt="Logo" className="w-64" />
            </Link>
          </div>
        )}
        <div className="w-full flex flex-col items-center justify-center mt-28">
          {/* Heading */}

          <h1 className="text-2xl sm:text-3xl font-semibold text-darkMode-text text-center mb-2">
            Register your Account {G && !D ? "Through Google" : !G && D ? "Through Dhan" : ""}
          </h1>
          <p className="text-darkMode-subText text-sm text-center mb-4 sm:mb-6">
            Create your account to get started
          </p>

          {/* Step Indicator */}
          {/* <div className="flex justify-between w-full sm:w-2/3 mb-6">
          {steps.map((step, index) => (
            <div key={index} className="flex flex-col items-center w-1/3">
              <div
                className={`h-8 w-8 flex items-center justify-center rounded-full border-2 text-sm ${
                  index <= currentStep
                    ? "border-green-500 bg-green-500 text-white"
                    : "border-gray-400 text-gray-400"
                }`}
              >
                {index + 1}
              </div>
              <Text
                className={`text-xs mt-2 ${
                  index <= currentStep ? "text-white" : "text-gray-500"
                }`}
              >
                {step.title}
              </Text>
              {index < steps.length - 1 && (
                <div
                  className={`h-0.5 w-full mt-3 ${
                    index < currentStep ? "bg-green-500" : "bg-gray-300"
                  }`}
                ></div>
              )}
            </div>
          ))}
        </div> */}

          {/* Form */}
          <div className="w-full xl:w-1/3 lg:w-2/3 ">
            <Form layout="vertical" onFinish={() => console.log("Signing up")}>
              {/* Dynamic Content */}
              <div>{steps[currentStep].content}</div>

              {/* Navigation Buttons */}
              <div className="flex flex-col sm:flex-row justify-between mt-6 gap-4">
                {currentStep > 0 && (
                  <Button
                    type="dashed"
                    onClick={prevStep}
                    className="w-full sm:w-auto border-gray-300"
                  >
                    Previous
                  </Button>
                )}
                {currentStep < steps.length - 1 ? (
                  <Button
                    type="dashed"
                    onClick={() => nextStep()}
                    className="w-full sm:w-auto bg-green-500 text-white"
                  >
                    Next
                  </Button>
                ) : (
                  <Button
                    htmlType="submit"
                    onClick={() => handleSubmit()}
                    className="w-full rounded-xl "
                    style={{
                      backgroundColor: colors.darkMode.green,
                      padding: 20,

                      borderColor: "#50CD89",
                    }}
                  >
                    <span className="text-green-900 sm:text-xl font-semibold">
                      {loading ? "Registering..." : "Register"}
                    </span>
                  </Button>
                )}
              </div>
              {!G && !D && (
                <>
                  <div className="flex items-center my-4">
                    <hr className="flex-grow border-t border-gray-300" />
                    <span className="mx-2 text-darkMode-subText text-sm">OR</span>
                    <hr className="flex-grow border-t border-gray-300" />
                  </div>
                  <GoogleBulbul
                    setPassword={setPassword}
                    setusername={setEmail}
                    setG={setG}
                    setName={setName}
                    setconfirmpass={setConfirmPassword}
                    fromLogin={false}
                  />
                  <DhanLogin from={"Signup"} />
                </>
              )}
            </Form>

          </div>
          {/* Login Link */}

          <div className="text-center mt-3 mb-2">
            <Text className="text-white text-xl">
              Already have an account?{" "}
              <Link to="/login">
                <span className="text-darkMode-green text-xl underline">
                  Log-In
                </span>
              </Link>
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserSignUp;
